import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation Mutation($data: CreateModalityInput!) {
    createModality(data: $data) {
      id
      name
      active
    }
  }
`);

export interface CreateGql {
  createModality: {
    id: number;
    name: string;
    active: boolean;
  };
}
